import { Component, Inject } from '@angular/core';

import { CompanyStateService } from 'src/app/auth/services/company-state.service';
import {
  BASE_PURCHASE_SERVICE,
  BasePurchaseService,
} from '../../services/base-purchase.service';
import { PurchaseStepsService } from '../../services/purchase-steps.service';
import { TaxExemptionService } from '../../services/tax-exemption.service';

@Component({
  selector: 'purchase-summary',
  templateUrl: './purchase-summary.component.html',
  styleUrls: ['./purchase-summary.component.scss'],
  standalone: false,
})
export class PurchaseSummaryComponent {
  addCoupon;
  purchase = this.purchaseService.purchase;
  selectedCompany = this.companyStateService.getCopyOfSelectedCompany();
  isSubcompanySelected = this.companyStateService.isSubcompanySelected();

  constructor(
    private companyStateService: CompanyStateService,
    @Inject(BASE_PURCHASE_SERVICE)
    public purchaseService: BasePurchaseService,
    public purchaseStepsService: PurchaseStepsService,
    public taxExemptionService: TaxExemptionService,
  ) {}

  applyCouponCode() {
    if (this.purchase.couponCode) {
      this.purchaseService.getEstimate().then(() => {
        if (!this.purchaseService.purchase.estimate.estimateError) {
          this.addCoupon = false;
        }
      });
    }
  }

  clearCouponCode() {
    this.purchase.couponCode = null;
    this.addCoupon = false;

    if (this.purchaseService.purchase.estimate.estimateError) {
      this.purchaseService.getEstimate();
    }
  }

  applyTaxExemption() {
    if (!this.taxExemptionService.taxExemption.sent) {
      this.taxExemptionService.taxExemption.show =
        !this.taxExemptionService.taxExemption.show;
    }
  }

  hasInteractivePlan() {
    return !!this.purchase.interactive;
  }

  hasAiCreditsPlan() {
    return !!this.purchase['ai-credits'];
  }

  getInteractivePlan() {
    return this.purchase.interactive;
  }

  getAiCreditsPlan() {
    return this.purchase['ai-credits'];
  }
}
